export const images = {
  minimis_logo: "/images/MINIMIS.svg",
  minimis_logo_footer: "/images/minimis_logo_footer.svg",
  hero_image: "/images/launcherPageImages/hero_image.webp",
  addictiveCardImage1: "/images/launcherPageImages/addictiveCardImage1.webp",
  addictiveCardImage2: "/images/launcherPageImages/addictiveCardImage2.webp",
  addictiveCardImage3: "/images/launcherPageImages/addictiveCardImage3.webp",
  addictiveCardImage4: "/images/launcherPageImages/addictiveCardImage4.webp",
  newsportImage: "/images/launcherPageImages/newsportImage.png",
  newsportImageMobile: "/images/launcherPageImages/newsportImageMobile.png",
  timeCardImage1: "/images/launcherPageImages/timeCardImage1.webp",
  timeCardImage2: "/images/launcherPageImages/timeCardImage2.webp",
  timeCardImage3: "/images/launcherPageImages/timeCardImage3.webp",
  timeCardImage4: "/images/launcherPageImages/timeCardImage4.webp",
  welcomeCardImage1: "/images/launcherPageImages/welcomeCardImage1.webp",
  welcomeCardImage2: "/images/launcherPageImages/welcomeCardImage2.webp",
  welcomeCardImage3: "/images/launcherPageImages/welcomeCardImage3.webp",
  welcomeCardImage4: "/images/launcherPageImages/welcomeCardImage4.webp",
  minimisLauncherPosterMobile: "/images/launcherPageImages/minimisLauncherPosterMobile.png",
  videoPosterImage: "/images/launcherPageImages/videoPosterImage.png",
  videoPlayButton: "/images/launcherPageImages/video-Play-Button.png",
  rating1: "/images/launcherPageImages/rating1.png",
  playstore: "/images/launcherPageImages/playstore.png",
  androidImage: "/images/launcherPageImages/android-mobile-launcher-image.png",
  playstoreIcon: "/images/launcherPageImages/play-store-icon.png",
  ratingstarImage: "/images/launcherPageImages/rating-star-image.png",
  rating_mobile: "/images/launcherPageImages/rating_mobile.webp",
  hands_icon: "/images/hands_icon.svg",
  payment_icon: "/images/payment_icon.svg",
  early_access_icon: "/images/checkoutPageImages/early_access_icon.svg",
  checkout_icon: "/images/checkoutPageImages/checkout_icon.svg",
  confirmation_icon: "/images/checkoutPageImages/confirmation_icon.svg",
  visa_card: "/images/checkoutPageImages/visa_card.svg",
  master_card: "/images/checkoutPageImages/master_card.svg",
  discover_card: "/images/checkoutPageImages/discover_card.svg",
  amex_card: "/images/checkoutPageImages/amex_card.svg",
  lock_icon: "/images/checkoutPageImages/lock_icon.svg",
  instagram: "/images/instagram.svg",
  linkedIn: "/images/linkedIn.svg",
  facebook: "/images/facebook.svg",
  dollar_icon: "/images/dollar_icon.svg"
};
